// extracted by mini-css-extract-plugin
export default {"headerImage":"Header_headerImage__IQzFH","btnOrange":"Header_btnOrange__xaili","caption":"Header_caption__li34c","feature":"Header_feature__b1NZh"};